import { Globe2 } from "lucide-react";

interface AustraliaCalloutProps {
  variant?: "block" | "strip";
  className?: string;
}

export function AustraliaCallout({ variant = "block", className = "" }: AustraliaCalloutProps) {
  if (variant === "strip") {
    return (
      <div
        className={
          "inline-flex items-center gap-2 text-xs font-mono tracking-[0.16em] uppercase text-[hsl(var(--brand-slate))] " +
          className
        }
        data-testid="badge-au-strip"
      >
        <Globe2 className="w-3.5 h-3.5 text-[hsl(var(--brand-forest))]" />
        <span>Hosted in Australia · Client data stored in Australia</span>
      </div>
    );
  }
  return (
    <div
      className={
        "rounded-xl border border-[hsl(var(--brand-sand))] bg-[hsl(var(--brand-bone))] p-5 sm:p-6 grid sm:grid-cols-[auto,1fr] gap-5 items-center " +
        className
      }
      data-testid="callout-au-data"
    >
      <div className="w-12 h-12 rounded bg-[hsl(var(--brand-forest))] text-[hsl(var(--brand-brass))] flex items-center justify-center shrink-0">
        <Globe2 className="w-6 h-6" />
      </div>
      <div className="text-sm text-[hsl(var(--brand-charcoal))] leading-relaxed">
        <div className="font-semibold mb-1">Australian data sovereignty, by default.</div>
        Client data — identities, bank details, addresses, audit history — is stored on Australian-based servers in the Sydney region. Backups are encrypted and region-locked. Transactional notifications (email, SMS) are delivered via sub-processors who receive only the minimum contact details required, under APP-aligned contractual safeguards.
      </div>
    </div>
  );
}
